// extracted by mini-css-extract-plugin
export default {"color-picker-popover":"style_color-picker-popover__kDZPz","color-picker-cover":"style_color-picker-cover__WjF6n","color-picker-button":"style_color-picker-button__KJlfl"};